import { ReactElement } from 'react';

import { Table, TableBody, TableContainer } from '@mui/material';

import { TableFlexOverflowContainer } from '@/components';

import { RecentActivityList } from './RecentActivityList';
// import { UsersPagination } from './UsersPagination';
import { RecentActivityTableHead } from './RecentActivityTableHead';

export const RecentActivityTable = (): ReactElement => {
  return (
    <TableFlexOverflowContainer>
      <TableContainer sx={{ border: 0 }}>
        <Table stickyHeader>
          <RecentActivityTableHead />
          <TableBody>
            <RecentActivityList />
          </TableBody>
        </Table>
      </TableContainer>

      {/* <UsersPagination /> */}
    </TableFlexOverflowContainer>
  );
};
